module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-modus__ansicht-wrapper"
  }, [_c('split-layout', {
    attrs: {
      "cols": 2,
      "sidebar_right_width": 'width:20% '
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus-main",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [_vm._t("modusindex-toolbar"), _vm._v(" "), _c('div', {
    staticClass: "ksm-modus__ansicht-main-wrapper"
  }, [_c('div', {
    staticClass: "ksm-modus__ansicht-main"
  }, [(_vm.seiteIdx < 1) ? _c('div', {
    staticClass: "ksm-ansicht__einfuehrung"
  }, [_c('div', {
    staticClass: "__title"
  }, [_vm._v("Einführung")]), _vm._v(" "), _c('div', {
    staticClass: "__body ksm-content-font ksm-hyphens",
    class: _vm.modusId,
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "lang": "de"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.einfuehrung)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ksm-ansicht-content"
  }, [_c('deepzoom-view', {
    key: "deep_ansicht_1",
    attrs: {
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx,
      "seiten": _vm.seiten
    },
    on: {
      "changePage": _vm.changeSeite
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ansicht-footer"
  }, [_c('foot-thumbnail', {
    attrs: {
      "seiten": _vm.seiten,
      "seiteIdx": _vm.seiteIdx,
      "aligen": 'horizontal'
    },
    on: {
      "selectItem": _vm.changeSeite
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [_c('sidebar-view', {
    attrs: {
      "merz": _vm.merz,
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0683510","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modus/Ansicht.vue
// module id = 1996
// module chunks = 1